import { render } from "./topicAdd.vue?vue&type=template&id=8d2f77d8&scoped=true"
import script from "./topicAdd.vue?vue&type=script&lang=js"
export * from "./topicAdd.vue?vue&type=script&lang=js"

import "./topicAdd.vue?vue&type=style&index=0&id=8d2f77d8&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d2f77d8"]])

export default __exports__